import { Prefill } from '@library/formBuilder/prefill';
import type { AtomModel } from '@models/atom.model';
import type { NumberFieldData } from '@stratumn/studio-shared';

type Props = {
  atom: AtomModel<NumberFieldData>;
};

export const NumberFieldModal = ({ atom }: Props) => (
  <>
    <Prefill atom={atom} />
  </>
);
